export const API_DEFAULT_COLORS = {
  PRIMARY: "#043544",
  SECONDARY: "#009999",
  ACCENT: "#42bfb3",
};

export const ORGANIZATION_COLORS = {
  API_CONNECT_DEFAULT: "default",
  CUSTOM: "custom",
}
